<template>
  <div>
    此份問卷尚未開放填答，請於{{ VaildInterval }}進行填答，謝謝。
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'InvaildEarly',
  data() {
    return {
      StartTime: this.$route.params.StartTime,
      EndTime: this.$route.params.EndTime
    };
  },
  computed: {
    VaildInterval() {
      return `${moment(this.StartTime).format('YYYY/MM/DD HH:mm')}~${moment(this.EndTime).format('YYYY/MM/DD HH:mm')}`;
    }
  }
};
</script>
